import type { JSX } from 'react'

export const EditPencilIcon = (): JSX.Element => (
  <use href='#editPencilIcon' height='100%' width='100%' />
)
